import { useContext } from 'react';
import RestaurantsContext from './restaurant-context';

export default () => {
  const results = useContext<any>(RestaurantsContext);
  return results;
};
